import 'babel-polyfill'

import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import App from './App'
import store from './store'
import router from './router'
import { sync } from 'vuex-router-sync'

const GoogleAnalyticsId = window && window.location &&
  window.location.href && window.location.href.includes('spinneybeck')
    ? 'UA-106859560-1' // spinneybeck
    : 'UA-106860522-1' // filzfelt

Vue.use(VueAnalytics, {
  id: GoogleAnalyticsId,
  router
})

sync(store, router)

export default new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})



// WEBPACK FOOTER //
// ./src/client/index.js